import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { Info } from "react-feather";
import EmployeePhoto from "./EmployeePhoto";
import { useGetPassTypeByIdQuery } from "AppQuries/master/PassType/pass-type";
import { format } from "date-fns";
import { Link } from "react-router-dom";
import ImageWithBasePath from "core/img/imagewithbasebath";

const DependantDetails = ({ employee }) => {
  return (
    <div className="view-employee-box mb-3">
      <div className="view-title">
        <h4>Dependant Details</h4>
      </div>
      <div className="view-employee-content">
        <div className="row">
        <div className="table-responsive">
          <table className="table table-responsive">
            <thead>
              <tr>
                <th>Name</th>
                <th>IC Number</th>
                <th>Applied Date</th>
                <th>Issued Date</th>
                <th>Expiry Date</th>
                <th>Fin</th>
                <th>Relationship</th>
                <th>Working</th>
                <th>Company Sponsored</th>
              </tr>
            </thead>
            <tbody>
              {employee?.dependantDetail?.map((d) => (
                <tr key={d.code}>
                  <td>{d.dependantName}</td>
                  <td>{d.icNumber}</td>
                  <td>{d.appliedOn && format(new Date(d.appliedOn), "yyyy-MM-dd")}</td>
                  <td>{d.issuedOn && format(new Date(d.issuedOn), "yyyy-MM-dd")}</td>
                  <td>{d.expiryDate &&  format(new Date(d.expiryDate), "yyyy-MM-dd")}</td>
                  <td>{d.fin}</td>
                  <td>{d.relationship}</td>
                  <td>{d.working}</td>
                  <td>{d.companySponsored}</td>
                </tr>
              ))}
            </tbody>
          </table>
          </div>
        </div>
      </div>
    </div>
  );
};

DependantDetails.propTypes = {
  employee: PropTypes.object.isRequired,
};

export default DependantDetails;
